import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  header: {
    display: 'flex',
    backgroundColor: theme.palette.headerColor.main,
    color: theme.palette.colors.light,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '58px',
    width: '100%',
    position: 'fixed',
    zIndex: 10,
  },
  headerNav: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 20,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
    },
  },
  headerLink: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
  },
  logoImg: {
    height: '30px',
    marginRight: 40,
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  mobileLogo: {
    height: '30px',
    display: 'flex',
    gap: 10,
    alignItems: 'center',
  },
}));

export default useStyles;
